import axios from "axios";
import { useMutation, useQuery } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";
import { getUserDetails } from "../utils/userDetailsUtils";

const saveExecutionSetup = async ({ productId, hubUrl }) => {
  try {
    const user = getUserDetails();

    const response = await axios.get(
      `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=saveExecutionSetup&hubUrl=${hubUrl}&companyId=${user.companyid}`,
    );

    return response.data;
  } catch (error) {
    console.error("Error saving execution setup:", error);
    throw error;
  }
};

const useExecutionSetup = (options = {}) => {
  return useMutation({
    mutationFn: saveExecutionSetup,
    ...options,
  });
};

const getExeUrls = async () => {
  const user = getUserDetails();

  const response = await axios.get(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=getExeUrls&companyId=${user.companyid}`,
  );

  return response.data;
};

export const useGetExeUrls = () =>
  useQuery({
    queryKey: ["exeUrls"],
    queryFn: getExeUrls,
  });

export default useExecutionSetup;
